<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/O7zCYi/tc-custom/9781626816671.jpg?1700957970801" alt="This image is the cover for the book Heart's Desire, Silver Creek Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heart's Desire, Silver Creek Stories
      </h1>
      <p class="bookDescription body article font2">
        <b>A woman out to find her father’s killer is undeniably drawn to the one man she shouldn’t trust in this historical western romance.</b><br/>  <br/> At a stage stop on the way to join her father in Silver Creek, Texas, Holly Campbell receives a telegram from her sister with news of his suicide. Shocked and heartbroken, Holly knows her father would never take his own life. Which leaves one unsettling possibility: murder. Now Holly must continue her journey in order to discover the truth.<br/>  <br/> Letters she had received from him make it clear that Sheriff Quintan Jarvis is as crooked as they come and not to be trusted. Holly means to keep as far away from him as possible. But even as she tries to resist her attraction to the mysterious sheriff, she can’t deny her body’s yearning for the handsome lawman’s embrace. Will she be able to solve the mystery of her father’s death before she surrenders to her heart’s desire?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vivian Vaughan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b32b5f8a